import { render, staticRenderFns } from "./msgProibidaForm.vue?vue&type=template&id=7b36ef7e&scoped=true"
import script from "./msgProibidaForm.vue?vue&type=script&lang=js"
export * from "./msgProibidaForm.vue?vue&type=script&lang=js"
import style0 from "./msgProibidaForm.vue?vue&type=style&index=0&id=7b36ef7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b36ef7e",
  null
  
)

export default component.exports